<template>
    <monitor-layout 
        v-bind:monitor_filter="monitor_filter" 
        v-bind:title="title" 
        v-on:updateFilters="_updateFilters" 
        v-on:updateFilterPreview="_updateFilterPreview"
        v-on:updateDates="_updateDates">
        <template v-slot:default="slotProps">
             <b-loading :is-full-page="isFullPage" :active.sync="showLoader"></b-loading>
            <div><!-- filtering partial of no partials in campaign makes chartData not responsive - so keep it as is -->
                <div class="chart-row">
                    <LineChartBox  :subLabels="{type: ['final', 'partial', 'none'], measurement: ['count', 'percent']}" subLabelType="twoSublabels" chartTitle="Conversions" :chartData="conversionsChart"> </LineChartBox>
                    <!--<LineChartBox v-else :subLabels="{type: ['final', 'none', ], measurement: ['count', 'percent']}" subLabelType="twoSublabels" chartTitle="Conversions" :chartData="filteredConversionsChart"> </LineChartBox>-->
                    <!--<LineChartBox v-else :subLabels="{measurement: ['count', 'percent']}" subLabelType="singleLabel" chartTitle="Conversions" :chartData="filteredConversionsChart"> </LineChartBox>-->
                    <LineChartBox :subLabels="{type: ['complete', 'partial', 'bounce'],measurement: ['count', 'percent']}" subLabelType="twoSublabels" chartTitle="Conversations" :chartData="conversationsChart"> </LineChartBox>
                </div>
                <div class="chart-row">
                    <LineChartBox :subLabels="{}" subLabelType="noLabel" chartTitle="Average Duration(s)" :chartData="averageDurationChart"> </LineChartBox>
                    <LineChartBox :subLabels="{}" subLabelType="noLabel" chartTitle="Average Impressions" :chartData="averageImpressionsChart"> </LineChartBox>
                </div>
                <ViewDetails v-if = "_dataExists(userDetails)":columnOrder= "columnOrder" :userDetails="userDetails"/></ViewDetails>
            </div>
        </template>
    </monitor-layout>
</template>
<script>
import MonitorLayout from './common/layout/MonitorLayout';
import monitorMixins from 'SrcRoot/mixins/monitor_mixins';
import campaignSceneDataMixin from 'SrcRoot/mixins/campaign_scene_data_mixin';
import LineChart from './charts/LineChart';
import { isEmpty, isEqual, cloneDeep } from "lodash";
import ViewDetails from './common/partials/ViewDetails';
import DoughnutChartBox from './common/chartbox/DoughnutChartBox';
import LineChartBox from './common/chartbox/LineChartBox';
import moment from 'moment';
import EventBus from "@/utils/event-bus";
import $ from 'jquery';

export default {
    name: "Conversations",
    mixins: [
        monitorMixins, campaignSceneDataMixin
    ],
    computed: {
        component_name() {
            return 'Conversations: ';
        },
        showLoader() {
            return  !this.visitorDataFetched;
        },
      
    },
    mounted() {
        this.$nextTick(() => { 
            this._setup();
            this.refreshSetInterval = setInterval(() => {
                this._refreshVisitorData();
            }, 30000); // Refresh visitor data every 30 seconds
           
        }); 
    },
    beforeDestroy() {
        clearInterval(this.refreshSetInterval); 
    },
    components: {
        'monitor-layout': MonitorLayout,
        ViewDetails,
        DoughnutChartBox,
        LineChartBox
    },
    data() {
        return {
            refreshSetInterval:"",
            impressions:{},
            duration:{},
            averageImpressionsChart:{},
            averageDurationChart:{},
        }
    },
    methods: { 
        initLocalData() {
            this.impressions={};
            this.duration={};
            this.conversations={};
            this.conversions={};
            //this.filteredConversionsChart={};
        },

        updateImpressionsChart() {
            this.$set(this, 'averageImpressionsChart', {});
            const impressions = this.impressions; // range has been filled
            const labels = Array.from({ length: Object.keys(impressions).length }, (_, i) => i);
            let averageImpressions = [];
            for (const date in impressions) {
                if (this.visitorsEachDay[date] == 0) averageImpressions.push(0);
                else {
                    const averageImpression = Number(((impressions[date]/this.visitorsEachDay[date])).toFixed(1));
                    averageImpressions.push(averageImpression);
                }  
            }
            this.$set(this.averageImpressionsChart, 'labels', labels);
            this.$set(this.averageImpressionsChart, 'datasets', [{
                category: '',
                data: averageImpressions
            }]);
            
        },

        updateDurationChart() {
            this.$set(this, 'averageDurationChart', {});
            const duration = this.duration; // range has been filled
            const labels = Array.from({ length: Object.keys(duration).length }, (_, i) => i);
            let averageDurations = [];
            for (const date in duration) {
                if (this.visitorsEachDay[date] == 0) averageDurations.push(0);
                else {
                    const averageDuration = Number(((duration[date]/this.visitorsEachDay[date])).toFixed(1));
                    averageDurations.push(averageDuration);
                }  
            }
            this.$set(this.averageDurationChart, 'labels', labels);
            this.$set(this.averageDurationChart, 'datasets', [{
                category: '',
                data: averageDurations
            }]);
            
        },
   
        updateConversationSummaryData() {
            this.initLocalData();
            //this._initVisitorsByDay(); // visitorsEachDay made a computed property
            
            const filteredVisitors = this._filterVisitors(); 
            for (const visitor of filteredVisitors) { // visitor session
                const { 
                    //total_bot_impressions: visit_impressions, 
                    total_conversation_duration: visit_duration,
                    conversation_bounces: visit_bounce, 
                    conversions:visit_conversions, // array of objects - since a campaign can have multiple conversion hooks
                    impressions,
                    created_at } = visitor;
                const date = moment(created_at).format('YYYY-MM-DD');
                if (impressions) {
                    if (!this.impressions[date]) this.impressions[date] = impressions.length;
                    else this.impressions[date] += impressions.length;

                } else { // legacy support - remove it later on - to do
                    if (!this.impressions[date]) this.impressions[date] = visit_impressions;
                    else this.impressions[date] += visit_impressions;
                }

                if (!this.duration[date]) this.duration[date] = Number(visit_duration);
                else this.duration[date] +=  Number(visit_duration);

                this._updateConversations(date, visit_bounce, impressions);
                this._updateConversions(date, visit_conversions);
            }
            
            this.fillDayRange();
            this.updateImpressionsChart();
            this.updateDurationChart();
            this._updateConversationsChart();
            this._updateConversionsChart();

            //this._filterPartialConversion(); this is a bug - filter it only when there are no partial conversations - will be done in template
        },

        fillDayRange() {
            const dateRange = this._createDateRange();
            for (const date of dateRange) {
                if (this.impressions[date] == undefined) this.impressions[date] = 0;
                if (this.duration[date] == undefined) this.duration[date] = 0;
                if (this.conversations[date] == undefined) this.conversations[date] = {'bounce':0, 'partial':0, 'complete':0}
                if (this.conversions[date] == undefined) this.conversions[date] = {'none':0, 'partial':0, 'final':0}
            }
            this.impressions = this._sortInDescendingOrderByDate(this.impressions);
            this.duration = this._sortInDescendingOrderByDate(this.duration);
            this.conversations = this._sortInDescendingOrderByDate(this.conversations);
            this.conversions = this._sortInDescendingOrderByDate(this.conversions);  
        },

        updateChartData() { // called from visitorsData watcher in monitor_mixin
            //console.log('updating conversations data');
            this.updateConversationSummaryData(); 
        },
        
    },
  
}
</script>
<style lang="scss" scoped>

@import "SrcRoot/modules/Campaign/components/monitor/scss/monitor.scss";

.conversations-content {
    width:100%;
    padding:0 0 30px;
    box-sizing:border-box;
}

.chart-row {
    width:100%;
    margin-left:0;
    justify-content:flex-start;
    gap:20px;

    ::v-deep .chart-box {
        width:calc(50% - 10px);
        max-width:none;
        flex:0 0 calc(50% - 10px);
        box-sizing:border-box;
    }
}

</style>
